

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import AutoWidthSelect from '../AutoWidthSelect';
import { plural, simplePlaceName, placeTypeName } from '../../utils/utils';
import styles from './ComparisonSelector.css';
import withStyles from '../../decorators/withStyles';
import {xlt} from '../../utils/utils';


class ComparisonSelector extends Component {

  static propTypes = {
    className: PropTypes.string,
    subRegions: PropTypes.array.isRequired,
    handleComparisonChange: PropTypes.func,
    placeName: PropTypes.string.isRequired,
    placeType: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {refs: []}
  }

  setTxContent = el => {
    d3.select(el).attr("tx-content", "block");
    // d3.select(el).attr("tx-dynamic", "disabled");
    // this.state.refs.push(el);
  };

  componentDidUpdate() {
    this.state.refs.forEach(el => {
      // console.log(el);
      // Transifex.live.translateNode(el);
    });
  }

  render() {
    const { placeType, subRegions, isEmbed, comparisonType, placeContainer, comparisonParent } = this.props;
    const placeName = simplePlaceName(this.props.placeName);

    // TODO: temporarily filter out state comparisons until we're ready to release.
    const options = subRegions.filter(subr => subr[0] !== "state").map(subr => {
      // Peer view
      if (subr[0] === placeType) {
        const containerName = simplePlaceName(comparisonParent);
        if (subr[0] === "place") {
          // placeContainer is a top-level container, such as a state.
          // comparisonParent is the most immediate container of a place, often a county.
          // This distinction is important for City places (population > 70000), which have state-level peer choropleths,
          // while town places have county-level peer chroropleths.
          if (this.props.population >= 70000) {
            return {value: subr[0], text: <span>in cities in <var>{xlt(placeContainer.name)}</var></span>}
          } else {
            return {value: subr[0], text: <span>in towns in <var>{xlt(containerName)}</var></span>}
          }
        } else {
          return {value: subr[0], text: <span><span> in </span><var>{xlt(plural(placeTypeName(subr[0], placeType)).toLowerCase())}</var><span> in </span><var>{xlt(containerName)}</var></span>}
        }
      // Towns and cities within place
      } else if (subr[0] === "place") {
        if (placeType === "state") {
          return {value: subr[0], text: <span>in <var>{xlt(placeName)}</var> by major city</span>}
        } else {
          return {value: subr[0], text: <span>in <var>{xlt(placeName)}</var> by <var>{xlt(subr[1].toLowerCase())}</var></span>}
        }
      // Other within place
      } else {
        return {value: subr[0], text: <span><span>in </span><var>{xlt(placeName)}</var><span> by </span><var>{xlt(placeTypeName(subr[0], placeType).toLowerCase())}</var></span>}
      }
    });

    return (
      (subRegions.length > 1) ?
        <div className="ComparisonSelector">
          <div className="dummy-option">{placeName}</div>
          <div className="dummy-option">{placeContainer.name}</div>
          <div className="dummy-option">{simplePlaceName(comparisonParent)}</div>
          {subRegions.map(subr => <div className="dummy-option" key={subr[0]}>{plural(placeTypeName(subr[0], placeType).toLowerCase())}</div>)}
          {subRegions.map(subr => <div className="dummy-option" key={subr[1]}>{subr[1].toLowerCase()}</div>)}
          {isEmbed ? <span>{options.find(opt => opt.value === comparisonType).text}</span>
            : <AutoWidthSelect options={options} handleChange={this.props.handleComparisonChange}
                           defaultValue={comparisonType} />
          }
        </div>
        :
        <span>
          <span>{options[0].text}</span>
        </span>
    );
  };

}

export default withStyles(styles)(ComparisonSelector);
